import React, { PropTypes, Component } from 'react';
import styles from './DownloadStep.css';
import withStyles from '../../decorators/withStyles';
import Steps from '../../actions/StepsActionCreator';
import Link from '../Link';
import Viewer from '../Viewer'
import BetaInfo from '../BetaInfo'

@withStyles(styles)
class DownloadStep extends Component {
  static propTypes = {
    downloadId: PropTypes.string.isRequired,
    name: PropTypes.string,
    height: PropTypes.number,
    uploadId: PropTypes.string
  };

  downloadHandler() {
    Steps.download(this.props.downloadId);
  }

  render() {
    var download = '/api/download/' + this.props.downloadId;
    var convert = '/convert/' + this.props.uploadId;
    return (
      <div className="DownloadStep">
        <div className="row">
          <div className="col-md-8 small-padding">
            <Viewer stlUrl={download} />
          </div>

          <div className="col-md-4 small-padding">
            <form method="get" action={download}>
              <button type="submit" className="btn btn-primary btn-block" onClick={this.downloadHandler}>Download</button>
            </form>
            <br/>
            <div className="alert alert-info">
              The 3D printable STL model for <strong><a href={convert} onClick={Link.handleClick}>{this.props.name}</a></strong> with a height of <strong>{this.props.height}mm</strong> should now show on the left side of this text.
              <br /><br />
              You can interact with it:
              <ul>
                <li>Left Mouse click and drag to rotate</li>
                <li>Right Mouse click and drag to pan</li>
                <li>Scroll Mouse to zoom</li>
                <li>F5 to reset view</li>
              </ul>
              <br />
              If you are on mobile:
              <ul>
                <li>Touch and drag to rotate</li>
                <li>Two fingers and drag to pan</li>
                <li>Pinch to zoom</li>
              </ul>

              <br />
              <BetaInfo />
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default DownloadStep;



/** WEBPACK FOOTER **
 ** ./src/components/DownloadStep/DownloadStep.js
 **/